(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('FncRxRepository', [
        'AprimaRestangular',
        'AprimaAnalytics',
        FncRxRepository
    ]);

    function FncRxRepository(
        AprimaRestangular,
        AprimaAnalytics
    ) {
        return {
            addPrescription: addPrescription,
            changeMedication: changeMedication,
            changeMedicationFromHistoryOnly: changeMedicationFromHistoryOnly,
            deleteRx: deleteRx,
            editPrescription: editPrescription,
            editPrescriptionDiagnosis: editPrescriptionDiagnosis,
            getAuthorizedPrescriberList: getAuthorizedPrescriberList,
            getDrugScreeningResults: getDrugScreeningResults,
            getNddDrugScreeningResultsFromPatient: getNddDrugScreeningResultsFromPatient,
            getNddDrugScreeningResults: getNddDrugScreeningResults,
            getPrescriberRights: getPrescriberRights,
            getSigwriterNddDrugScreeningResults: getSigwriterNddDrugScreeningResults,
            getVisitMedStatus: getVisitMedicationStatus,
            getVisitMedStatuses: getVisitMedicationStatuses,
            getVisitPrescriptions: getVisitPrescriptions,
            refillMedication: refillMedication,
            refillMedicationFromPreviousVisit: refillMedicationFromPreviousVisit,
            startChange: startChange,
            startChangeFromHistoryOnly: startChangeFromHistoryOnly,
            startCppMedication: startCppMedication,
            startRefill: startRefill,
            startRefillFromPreviousVisit: startRefillFromPreviousVisit,
            startRefills: startRefills,
            updateRxPharmacies: updateRxPharmacies,
            getQueuedMedications: getQueuedMedications,
            deleteQueuedMedication: deleteQueuedMedication,
            updateRxRefill:updateRxRefill
        };

        function addPrescription(patientId, visitId, prescription) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'addPrescription');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('patients/' + patientId + '/fnc/' + visitId + '/rx/addprescription')
                .post(prescription)
                .finally(timing.stop);
        }

        function deleteRx(relVisitMedicationId) {
            return AprimaRestangular.get()
                .one('fnc/rx', relVisitMedicationId)
                .remove();
        }

        function getAuthorizedPrescriberList(sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getAuthorizedPrescriberList');
            return AprimaRestangular.get()
                                    .all('fnc/rx/authorizedprescriberlist')
                                    .getList({
                                        sigType: sigType,
                                    })
                                    .finally(timing.stop);            
        }

        function editPrescription(patientId, visitId, prescription) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'editPrescription');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('patients/' + patientId + '/fnc/' + visitId + '/rx/editprescription')
                .post(prescription)
                .finally(timing.stop);
        }

        function editPrescriptionDiagnosis(patientId, visitId, relVisitMedicationId, problems) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'editPrescriptionDiagnosis');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('patients/' + patientId + '/fnc/' + visitId + '/rx/' + relVisitMedicationId + '/editprescriptiondiagnosis')
                .post(problems)
                .finally(timing.stop);
        }

        function getDrugScreeningResults(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'drugScreening');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/screening')
                              .get()
                              .finally(timing.stop);
        }

        function getNddDrugScreeningResultsFromPatient(patientId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getNddDrugScreeningResultsFromPatient');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/rx/nddscreening')
                              .get()
                              .finally(timing.stop);
        }

        function getNddDrugScreeningResults(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'nddDrugScreening');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/nddscreening')
                              .get()
                              .finally(timing.stop);
        }

        function getPrescriberRights() {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getPrescriberRights');
            return AprimaRestangular.get()
                                    .one('fnc/rx/prescriberrights')
                                    .get()
                                    .finally(timing.stop);   
        }

        function getSigwriterNddDrugScreeningResults(patientId, visitId, drug, medicationSigId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'sigwriterDrugScreening');
            var restangular = AprimaRestangular.get();
            return restangular.all('patients/' + patientId + '/fnc/' + visitId + '/rx/sigwriter/nddscreening')
                              .post({
                                  Drug: drug,
                                  MedicationSigId: medicationSigId,
                              })
                              .finally(timing.stop);
        }

        function getVisitMedicationStatus(relVisitMedicationId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getVisitMedicationStatus');
            var restangular = AprimaRestangular.get();

            var promise = restangular
                .all('fnc')
                .all('rx')
                .one('visit-medication-status', relVisitMedicationId)
                .get()
                .finally(timing.stop);

            return promise;
        }

        function getVisitMedicationStatuses(relVisitMedicationIdList) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getVisitMedicationStatuses');
            var restangular = AprimaRestangular.get();
            var params = {
                relVisitMedicationIds: relVisitMedicationIdList,
            };

            var promise = restangular
                .all('fnc')
                .all('rx')
                .all('visit-medication-status')
                .customGET('', params)
                .then(function(data) {
                    if(!data || !data.Results) {
                        return $q.reject('Could not retrieve medication statuses');
                    }

                    // Results is a dictionary with the key being the RelVisitMedicationUid,
                    // and the value being the med status
                    return data.Results;
                })
                .finally(timing.stop);

            return promise;
        }

        function getVisitPrescriptions(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getVisitPrescriptions');
            return AprimaRestangular.get()
                                    .all('patients/' + patientId + '/fnc/' + visitId + '/rx')
                                    .getList()
                                    .finally(timing.stop);
        }

        function getQueuedMedications(patientId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getVisitPrescriptions');
            return AprimaRestangular.get()
                                    .all('patients/' + patientId + '/fnc/queued-rx')
                                    .getList()
                                    .finally(timing.stop);
        }

        function deleteQueuedMedication(relVisitMedicationId) {
            return AprimaRestangular.get()
                                    .one('/fnc/queued-rx', relVisitMedicationId)
                                    .remove();
        }

        function changeMedication(patientId, visitId, relPatientMedicationId, prescription) {
                var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'changeMedication');
                var restangular = AprimaRestangular.get();
                return restangular.all('patients/' + patientId + '/fnc/' + visitId + '/rx/change-prescription')
                    .post({
                        Prescription: prescription,
                        RelPatientMedicationId: relPatientMedicationId,
                    })
                .finally(timing.stop);
        }

        function changeMedicationFromHistoryOnly(patientId, visitId, relPatientMedicationId, prescription) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'changeMedicationFromHistoryOnly');
            var restangular = AprimaRestangular.get();
            return restangular.all('patients/' + patientId + '/fnc/' + visitId + '/rx/change-prescription-from-history-only')
                .post({
                    Prescription: prescription,
                    RelPatientMedicationId: relPatientMedicationId,
                })
            .finally(timing.stop);
        }

        function refillMedication(patientId, visitId, relPatientMedicationId, prescription) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'refillMedication');
            var restangular = AprimaRestangular.get();
            return restangular.all('patients/' + patientId + '/fnc/' + visitId + '/rx/refillprescription')
                              .post({
                                  Prescription: prescription,
                                  RelPatientMedicationId: relPatientMedicationId,
                              })
                              .finally(timing.stop);
        }

        function refillMedicationFromPreviousVisit(patientId, visitId, relVisitMedicationId, prescription) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'refillMedicationFromPreviousVisit');
            var restangular = AprimaRestangular.get();

            var promise = restangular
                .one('patients', patientId)
                .one('fnc', visitId)
                .all('rx/refill-previous-visit-prescription')
                .post({
                    Prescription: prescription,
                    SelectedRelVisitMedicationId: relVisitMedicationId,
                })
                .finally(timing.stop);
            return promise;
        }

        function startChange(patientId, visitId, relPatientMedicationId, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startChange');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/start-change')
                .get({
                    relPatientMedicationId: relPatientMedicationId,
                    sigType: sigType,
                })
                .finally(timing.stop);
        }

        function startChangeFromHistoryOnly(patientId, visitId, relPatientMedicationId, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startChangeFromHistoryOnly');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/start-change-from-history-only')
            .get({
                relPatientMedicationId: relPatientMedicationId,
                sigType: sigType,
            })
            .finally(timing.stop);
        }

        function startCppMedication(patientId, visitId, cppMedicationId, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startCppMedication');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/start-cpp-medication')
                              .get({
                                  cppMedicationId: cppMedicationId,
                                  sigType: sigType,
                               })
                              .finally(timing.stop);
        }

        function startRefill(patientId, visitId, relPatientMedicationId, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startRefill');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/startrefill')
                              .get({
                                  relPatientMedicationId: relPatientMedicationId,
                                  sigType: sigType,
                               })
                              .finally(timing.stop);
        }

        function startRefillFromPreviousVisit(patientId, visitId, relVisitMedicationId, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startRefillFromPreviousVisit');
            var restangular = AprimaRestangular.get();

            var promise = restangular
                .one('patients', patientId)
                .one('fnc', visitId)
                .customGET('rx/start-previous-visit-refill', {
                    relVisitMedicationId: relVisitMedicationId,
                    sigType: sigType,
                })
                .finally(timing.stop);
            return promise;
        }

        function startRefills(patientId, visitId, relPatientMedicationIds, sigType) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'startRefills');
            var restangular = AprimaRestangular.get();
            return restangular.one('patients/' + patientId + '/fnc/' + visitId + '/rx/startrefills')
                              .get({
                                  relPatientMedicationIds: relPatientMedicationIds,
                                  sigType: sigType,
                               })
                              .finally(timing.stop);
        }

        function updateRxPharmacies(relVisitMedicationIds, patientId, pharmacyId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'updateRxPharmacies');
            return AprimaRestangular.get()
                .all('fnc/rx/pharmacy')
                .post({RelVisitMedicationIds: relVisitMedicationIds, PatientId: patientId, PharmacyId: pharmacyId})
                .finally(timing.stop);
        }

        function updateRxRefill(patientId, visitId, relVisitMedicationId, refillQty, medicaitonDays) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'editPrescription');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('patients/' + patientId + '/fnc/' + visitId + '/rx/'+relVisitMedicationId+'/refill/'+refillQty+'/days/'+medicaitonDays)
                .post()
                .finally(timing.stop);
        }
    }
})(angular);